import { createSlice } from "@reduxjs/toolkit";

export const initialState = {
  forgetSuccessMsg: null,
  forgetError: null,
  loading: false,
};

const forgotPasswordSlice = createSlice({
  name: "forgotpwd",
  initialState,
  reducers: {
    userForgetPasswordSuccess(state, action) {
      state.forgetSuccessMsg = action.payload;
    },
    userForgetPasswordError(state, action) {
      state.forgetError = action.payload;
    },
    loadingData(state, action) {
      state.loading = action.payload;
    },
  },
});

export const {
  userForgetPasswordSuccess,
  userForgetPasswordError,
  loadingData,
} = forgotPasswordSlice.actions;

export default forgotPasswordSlice.reducer;
